export const DEEP_LINKING_ACTIONS = {
  item_edit: 'item_edit',
};
